import React from 'react';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from '../../services/helpers.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function CriticalIllness({ classes, expanded, criticalIllness, handleChange, isStudent }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('criticalIllness')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('criticalIllness') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles.criticalIllness) }</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>

                    {
                        criticalIllness.isEligible !== 1 ? 
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.ineligibleForBenefit) }
                                </Text>
                            </div>
                            : 
                            null
                    } 

                    {
                        criticalIllness.flatAmount > 0 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.criticalIllnessCoverageAmount, { flatAmount: numberWithCommas(criticalIllness.flatAmount) }) }
                                </Text>
                            </div>
                            :
                            null
                    }

                    {  
                        criticalIllness.maxEvidence > 0 ?
                            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.maxEvidenceLabel, { maxEvidence: numberWithCommas(criticalIllness.maxEvidence) })}</Text>
                            :
                            null
                    }
                    {
                        criticalIllness.maxNoEvidence > 0 ?
                            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.maxNoEvidenceLabel, { maxNoEvidence: numberWithCommas(criticalIllness.maxNoEvidence) }) }</Text>
                            :
                            null
                    }

                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.coverageReducesAtAge, { reducesBy: criticalIllness.reducesBy, reducesAtAge: criticalIllness.reducesAtAge })}</Text>

                    {
                        criticalIllness.includeSecondReduction ?
                            <Text small margin="5px 0px 10px 0px">{ i18n.t(tokens.labels.coverage.furtherCoverageReducesAtAge, { furtherReducesBy: criticalIllness.furtherReducesBy, furtherReductionAge: criticalIllness.furtherReductionAge })}</Text>
                            :
                            null
                    }

                    {
                        isStudent ?
                            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtEndOfStudy, { terminationAge: criticalIllness.terminationAge }) }</Text>
                            :
                            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: criticalIllness.terminationAge }) }</Text>
                    }

                </AccordionDetails>
            </Accordion>
        </div>
    );
}